<!-- Labeled Button Component -->
@if (type !== 'icon' && type !== 'image') {
  <button
    [id]="id"
    class="flex items-center justify-center px-4 py-2 text-nowrap transition-all duration-300"
    [ngClass]="getButtonClasses()"
    [attr.type]="buttonType"
    (click)="$event.stopPropagation(); onClickButton($event)"
    [disabled]="disabled"
    [ngStyle]="{
    'height': computedButtonDimensions.height,
    'width,': computedButtonDimensions.width,
    'border-radius': borderRadius,
    }"
  >
    <!-- Left Icon -->
    @if (iconPosition === 'left') {
      <ng-container>
        @if (icon) {
          <ng-container>
            <span [ngClass]="{
              'text-white ': type === 'primary' || type === 'success' || type === 'error',
              'text-primary ': type === 'outlined',
              'text-primaryText': type === 'load',
              'text-secondaryText': type === 'secondary',
              fontSize
            }" class="material-icons mr-2">{{ icon }}</span>
          </ng-container>
        }
        @if (image) {
          <ng-container>
            <img
              [src]="image.src"
              [alt]="image.alt || ''"
              [width]="image.width || '18'"
              class="mr-2"
            />
          </ng-container>
        }
      </ng-container>
    }

    <!-- Button Label -->
    @if (label) {
      <ng-container>
    <span
      class="font-mRegular"
      [ngClass]="{
      'text-white ': type === 'primary' || type === 'success' || type === 'error',
      'text-primary ': type === 'outlined',
      'text-primaryText': type === 'load',
      'text-blackFont': type === 'secondary',
      fontSize
    }"
    >{{ label }}</span
    >
      </ng-container>
    }

    <!-- Right Icon -->
    @if (iconPosition === 'right') {
      <ng-container>
        @if (icon) {
          <ng-container>
            <span class="material-icons ml-2">{{ icon }}</span>
          </ng-container>
        }
        @if (image) {
          <ng-container>
            <img
              [src]="image.src"
              [alt]="image.alt || ''"
              [width]="image.width || '18'"
              class="ml-2"
            />
          </ng-container>
        }
      </ng-container>
    }
  </button>
}

<!-- Icon: For Icon Button -->
@if (type === 'icon') {
  <button
    [id]="id"
    class="w-16 h-12 flex items-center justify-center rounded-xl bg-gray-200 text-gray-700 disabled:opacity-50"
    (click)="$event.stopPropagation(); onClickButton($event)"
    [ngStyle]="{'border-radius': borderRadius,}"
  >
    <span class="material-icons text-xl text-secondary">{{ icon }}</span>
  </button>
}

<!-- Image: For Image Button -->
@if (type === 'image') {
  <button
    [id]="id"
    class="w-16 h-12 flex items-center justify-center rounded-xl bg-gray-200 text-gray-700 disabled:opacity-50"
    (click)="$event.stopPropagation(); onClickButton($event)"
  >
    <img [src]="imageSource" [alt]="icon" class="object-cover"
         [ngStyle]="{'border-radius': borderRadius,}"/>
  </button>
} @else {

}

